import type { CanActivateChildFn } from '@angular/router';
import { userBuildingPermissionLoadedGuard } from './user-building-permission-loaded-guard';

/**
 * Re-checks building context on child navigations. This expects
 * `userBuildingPermissionLoadedGuard` to run on the parent `:buildingId` route.
 */
export const buildingContextHealthGuard: CanActivateChildFn = (route) => {
    const target =
        route.pathFromRoot.find((snapshot) =>
            snapshot.paramMap.has('buildingId')
        ) ?? route;
    return userBuildingPermissionLoadedGuard(target);
};
